class Debug{
    static info(log){
        console.log(log);
    }
    static success(log){
        console.log('%c'+log, "color: green;");
    }
    static warn(log){
        console.log('%c'+log, "color: orange;");
    }
    static error(log){
        console.log('%c'+log, "color: red;");
    }
    static highlight(log){
        console.log('%c'+log, "background: yellow;");
    }
}